export class OverrideStyles {
  constructor() {
    this.nodes = document.querySelectorAll('.blog [data-mce-style="font-weight: 400;"]');
  }

  initialize() {
    if (this.nodes.length) {
      this.nodes.forEach((node) => {
        node.style.fontWeight = '100';
      });
    }
  }
}
